import { render } from "./trace.vue?vue&type=template&id=4635d982&scoped=true&ts=true"
import script from "./trace.vue?vue&type=script&lang=ts"
export * from "./trace.vue?vue&type=script&lang=ts"

import "./trace.vue?vue&type=style&index=0&id=4635d982&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4635d982"]])

export default __exports__